export enum ProviderActionsTabsEnum {
  Targeted = "targeted",
  Terminated = "terminated",
  Excluded = "excluded"
}

export enum ProcessStatusEnum {
  Processed = "processed",
  Unprocessed = "unprocessed"
}

export enum ProviderActionsFlyoutEnum {
  NetNew = "netNew",
  Projection = "projection",
  Termination = "termination",
}